import { InternalStakeholder } from '@blisspointmedia/bpm-types/dist/ClientOracleOnboarding';

// Text inputs cannot hold null, so nullable roster fields become empty strings here.
export interface TeamMemberEdits {
  name: string;
  pronouns: string;
  title: string;
  roleOnAccount: string;
}

export const EMPTY_TEAM_MEMBER_EDITS: TeamMemberEdits = {
  name: '',
  pronouns: '',
  title: '',
  roleOnAccount: ''
};

export const toTeamMemberEdits = (stakeholder: InternalStakeholder): TeamMemberEdits => ({
  name: stakeholder.name,
  pronouns: stakeholder.pronouns ?? '',
  title: stakeholder.title ?? '',
  roleOnAccount: stakeholder.roleOnAccount ?? ''
});

export const isTeamMemberEditsValid = ({ name }: TeamMemberEdits): boolean =>
  name.trim().length > 0;

// Validation ignores surrounding whitespace, so the saved values have to as well.
export const normalizeTeamMemberEdits = (edits: TeamMemberEdits): TeamMemberEdits => ({
  name: edits.name.trim(),
  pronouns: edits.pronouns.trim(),
  title: edits.title.trim(),
  roleOnAccount: edits.roleOnAccount.trim()
});
